export default __webpack_public_path__ + "assets/png/a2bd3b4c4ded03a4851f466ca5623def.png";